/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-view-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm9.337-2.713A10.431 10.431 0 0010 3.125 10.431 10.431 0 00.662 9.787a.625.625 0 000 .425A10.431 10.431 0 0010 16.876a10.431 10.431 0 009.337-6.662.625.625 0 000-.425zM10 14.063A4.062 4.062 0 1114.063 10 4.069 4.069 0 0110 14.063z"/>'
  }
})
